import { Link } from "react-router";
import "../../styles/common/footer.css";
import logo_2 from "../../assets/home_page/Logo_2.svg";
import insta from "../../assets/social/insta.svg";
import { ReactComponent as Substack } from "../../assets/social/substack.svg";
import youtube from "../../assets/social/youtube.svg";
import linkedin from "../../assets/social/linkedin.svg";
import footer from "../../assets/home_page/footer.svg";
import email from "../../assets/icons/email.svg";
import phone from "../../assets/icons/phone.svg";

function Footer() {
  return (
    <>
      <div className="footer_design">
        <img src={footer} alt="footer design" />
      </div>
      <footer>
        <div className="footer-container">
          <div className="row1">
            <div className="title">
              <p>Connect with Us</p>
            </div>

            <div className="row1-links">
              <Link
                to="https://makerghat.org/about-us/our-story"
                className="link"
                target="_blank"
                rel="noreferrer"
              >
                About Us
              </Link>
              <Link
                to="https://makerghat.org/get-involved/partner"
                className="link"
                target="_blank"
                rel="noreferrer"
              >
                Partner
              </Link>
              <Link
                to="https://makerghat.org/get-involved/careers"
                className="link"
                target="_blank"
                rel="noreferrer"
              >
                Careers
              </Link>
              <Link
                to="https://makerghat.org/get-involved/volunteer"
                className="link"
                target="_blank"
                rel="noreferrer"
              >
                Volunteer
              </Link>
              <Link
                to="https://makerghat.org/get-involved/donate"
                className="link"
                target="_blank"
                rel="noreferrer"
              >
                Donate
              </Link>
            </div>

            <img src={logo_2} alt="Logo" className="tablet-logo" />
          </div>

          <div className="row-1">
            <div className="col col1">
              <div>
                <div className="title">
                  <div className="title-text">
                    <p>Connect</p>
                    <p>with Us</p>
                  </div>

                  <img src={logo_2} alt="Logo" className="mobile-logo" />
                </div>

                <div className="links">
                  <Link
                    to="https://makerghat.org/about-us/our-story"
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    About Us
                  </Link>
                  <Link
                    to="https://makerghat.org/get-involved/partner"
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Partner
                  </Link>
                  <Link
                    to="https://makerghat.org/get-involved/careers"
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Careers
                  </Link>
                  <Link
                    to="https://makerghat.org/get-involved/volunteer"
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Volunteer
                  </Link>
                  <Link
                    to="https://makerghat.org/get-involved/donate"
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Donate
                  </Link>
                </div>
              </div>
            </div>

            <div className="col col2">
              <h2>MG Pillars</h2>
              <div className="links">
                <Link
                  to="https://makerghat.org/space/makerspace"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Space
                </Link>
                <Link
                  to="https://makerghat.org/curriculum/framework"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Curriculum
                </Link>
                <Link
                  to="https://makerghat.org/training"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Training
                </Link>
                <Link
                  to="https://makerghat.org/evidence/framework"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Evidence
                </Link>
              </div>
            </div>

            <div className="col col3">
              <h2>Programs</h2>
              <div className="links">
                <Link
                  to="https://makerghat.org/programs/makerghat-fellowship"
                  className="link"
                  target="_blank"
                >
                  MakerGhat Fellowship
                </Link>
                <Link
                  to="https://makerghat.org/programs/shikshagraha"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Shikshagraha
                </Link>
              </div>
            </div>

            <div className="col col4">
              <h2>Resources</h2>
              <div className="links">
                <Link
                  to="https://makerghat.org/curriculum/framework#framework"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Curriculum framework
                </Link>
                <Link
                  to="https://makerghat.orgevidence/framework#skills"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Skills definition guide
                </Link>
                <Link
                  to="https://makerghat.org/curriculum/resources"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Curriculum resources
                </Link>
                <Link
                  to="https://makerghat.org/evidence/dashboard"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Dashboard
                </Link>
                <Link
                  to="https://makerghat.org/evidence/reports"
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Reports
                </Link>
              </div>
            </div>

            <div className="col col5">
              <img src={logo_2} alt="Logo" className="logo" />
              <div className="form">
                <Link to="https://makerghat.substack.com/">
                  <p>Subscribe to our newsletter</p>
                </Link>
              </div>
            </div>
          </div>

          <div className="line"></div>

          <div className="row-2">
            <div className="col col1">
              <div className="phone">
                <img src={phone} alt="phone" />
                <a href="tel:+919447756484" className="links">
                  +91 9447756484
                </a>
              </div>
              <div className="email">
                <img src={email} alt="email" />
                <a href="mailto:info@makerghat.org" className="links">
                  info@makerghat.org
                </a>
              </div>
              <div className="copyright">
                <p>MakerGhat and its assets are licensed</p>
                <p>under CC BY-SA4.0</p>
              </div>
            </div>

            <div className="col col2">
              <div className="copyright">
                <p>MakerGhat and its assets are licensed</p>
                <p>under CC BY-SA4.0</p>
              </div>
            </div>

            <div className="col col3">
              <div className="form">
                <Link to="https://makerghat.substack.com/">
                  <p>Subscribe to our newsletter</p>
                </Link>
              </div>

              <div className="line"></div>

              <div className="social">
                <Link
                  to="https://www.instagram.com/makerghat?igsh=c3V6NDRyNmJ0MzY4"
                  target="_blank"
                >
                  <img src={insta} alt="insta" />
                </Link>
                <Link
                  to="https://makerghat.substack.com/"
                  target="_blank"
                  className="substack"
                >
                  <Substack className="substack-logo" />
                </Link>
                <Link
                  to="https://youtube.com/@makerghat9609?si=_3-8xF0F_6kY-ZC4"
                  target="_blank"
                >
                  <img src={youtube} alt="youtube" />
                </Link>
                <Link
                  to="https://www.linkedin.com/company/makerghat"
                  className="linkedin"
                  target="_blank"
                >
                  <img src={linkedin} alt="linkedin" />
                </Link>
              </div>
              <div className="copyright">
                <p>MakerGhat and its assets are licensed</p>
                <p>under CC BY-SA4.0</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
